










































import _ from "lodash";
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Mixins,
} from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Role from "@/store/entities/role";
import RoleTreeMixin from "./roleTree";
@Component
export default class CreateRole extends Mixins(AbpBase, RoleTreeMixin) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  role: Role = new Role();
  get permissions() {
    return this.$store.state.role.permissions;
  }
  get rolePermissions() {
    return this.role.permissions;
  }
  treeData = [];
  save() {
    (this.$refs.roleForm as any).validate(async (valid: boolean) => {
      if (valid) {
        const selectedNotes = (this.$refs[
          "tree"
        ] as any).getCheckedAndIndeterminateNodes();
        const selectedPermissions = _.map(selectedNotes, (n) => n.key);
        this.role.permissions = selectedPermissions;
        if (!this.role.permissions) {
          this.role.permissions = [];
        }
        await this.$store.dispatch({
          type: "role/create",
          data: this.role,
        });
        (this.$refs.roleForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.roleForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
    this.treeData = this.initTree(_.map(this.permissions, (p) => p.name));
  }
  roleRule = {
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("RoleName")),
        trigger: "blur",
      },
    ],
    displayName: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("DisplayName")
        ),
        trigger: "blur",
      },
    ],
  };
}
